import pages from './pages.json' with { type: 'json' };

export default {
  pages,
};
